<template>
    <div>
        <template v-if="isActivity || isMemberAdmin">
        <!-- <template v-if="use_cmp_user_edit"> -->
            <user-list-item-edit 
                :hide_activity_buttons="hide_activity_buttons"
                :caption="user_name" 
                :attendee="{user_id: user_id, user_type: 'member', status: isMemberAdmin && this.$route.name != 'event-detail' && this.$route.name != 'presence' ? user_status : attendee.status}"
                :contact_email="user_contact_email"
                :contact_mobile="user_contact_mobile"
                :agenda_hash="agenda_hash" 
                :class="count_guest > 0 || count_spouse > 0 ? 'mb-2' : ''"
                :thumbnail="thumbnail"
                :user_active="user_active"
                :user_suspend="user_suspend"
            ></user-list-item-edit>
            <user-list-item-edit 
                v-if="use_cmp_user_edit && attendee.spouse.status === '0'"
                caption="Partner" 
                :attendee="{user_id: user_id, user_type: 'spouse', status: attendee.spouse.status}" 
                :agenda_hash="agenda_hash" 
                :class="count_guest > 0 ? 'mb-2' : ''"
            ></user-list-item-edit>
            <user-list-item-edit 
                v-for="(guest, guest_i) in attendee.guests" :key="guest_i"
                caption="Gast" 
                :attendee="{user_id: user_id, user_type: 'guest', status: guest.status, guest_key: guest_i}" 
                :agenda_hash="agenda_hash" 
                :class="guest_i < attendee.guests.length ? 'mb-2' : ''"  
            ></user-list-item-edit>
        </template>
        <template v-else>
            <div class="d-flex align-items-center justify-content-between">
                <user-thumbnail :thumbnail="thumbnail" ></user-thumbnail>
                <div class="user-list-item__details flex-fill">
                    <strong class="user-list-item__title">{{ user_name }} <span v-if="user_suspend"> (Beurlaubt)</span> <span v-if="!user_active"> (Nicht aktiv)</span></strong>
                    <p v-if="user_contact_email" v-html="user_contact_email"></p>
                    <p v-if="user_contact_mobile" v-html="user_contact_mobile"></p>
                    <small class="d-block" v-if="hide_activity_buttons">{{ user_status }}</small>
                    <span class="user-list-item__meta">
                        {{ text_spouse }}
                        <template v-if="count_guest > 0 && count_spouse > 0"> / </template>
                        {{ text_guest }}</span>

                    <!-- <router-link :to="{ name: 'user-view', params: { Id: user_id }}" class="user-list-item__view">
                        <svg-icon-social class="user-list-item__svg"></svg-icon-social>
                        Kontaktdaten anzeigen
                    </router-link> -->
                </div>
                <router-link v-if="!hideDetailButton" :to="{ name: 'user-view', params: { Id: user_id }}" class="user-list-item__edit bg-primary text-white">
                    <font-awesome-icon fixed-width :icon="['far', 'user']" />
                </router-link>
            </div>
        </template>
        
    </div>

</template>

<script>
import { mapGetters} from "vuex";
import UserListItemEditVue from './UserListItemEdit.vue';
import UserThumbnailVue from './UserThumbnail.vue';
export default {
    name: 'user-list-item',
    components: {
        'user-thumbnail': UserThumbnailVue,
        'user-list-item-edit': UserListItemEditVue
    },
    props: {
        attendee: {
            type: Object,
            default: () => {
                return {
                    status: false,
                    spouse: {}
                }
            }
        },
        agenda_hash: {
            type: String
        },
        user_name: {
            type: String
        },
        user_id: {
            type: Number
        },
        // user_status: {
        //     type: String,
        //     default: 'Mitglied'
        // },
        user_role: {},
        count_guest: {
            type: Number,
            default: 0
        },
        count_spouse: {
            type: Number,
            default: 0
        },
        hide_activity_buttons: {
            type: Boolean,
            default: false
        },
        thumbnail: {
            type: String,
            default: ''
        },
        user_active: {
            type: Boolean,
            default: true
        },
        user_suspend: {
            type: Boolean,
            default: false
        },
        user_contact_mobile: {
            type: String,
            default: ''
        },
        user_contact_email: {
            type: String,
            default: ''
        },
        hideDetailButton: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('auth', ['isActivity', 'isMemberAdmin']),
        text_spouse() {
            if (this.count_spouse == 0) {
                return '';
            }
            return `${this.count_spouse} Partner`;
        },
        text_guest() {
            if (this.count_guest == 0) {
                return '';
            }
            const text = this.count_guest > 1 ? 'Gäste' : 'Gast';
            return `${this.count_guest} ${text}`;
        },
        user_status() {
            const roles = [];
            if (!this.user_role) {
                return 'Mitglied';
            }
            if (this.user_role.length > 0) {
                this.user_role.forEach(role => {
                    roles.push(role.post_title);
                });
                return roles.sort().join(', ');
            } else {
                return 'Mitglied';
            }
        },
        use_cmp_user_edit() {
            if (this.$route.name =='users') {
                return false;
            } else {
                return this.isActivity || this.isMemberAdmin;
                // return false;
            }
        }
    }
}
</script>

<style lang="scss">
@import '../scss/variables';
.card {
    &.user-list-item {
        background-color: $gray-4;
        font-size: 14px;
        color: $primary;
        line-height: 1.2;

        .user-list-item {
            &__details {
                padding: 0 10px;
                // width: 100%;
            }

            &__title {
                font-weight: $font-weight-bold;
            }
    
            &__meta {
                display: block;
                font-size: 10px;
            }

            &__status,
            &__edit {
                // font-size: 29px;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                text-align: center;
                transition: all .3s ease-in-out;
            }

            &__edit {
                font-size: 17px;
                margin-left: 10px;
                border: 1px solid rgba(#707070, .7);

                &.disabled {
                    opacity: .3;
                }

                &.bg-dark {
                    margin-left: 0;
                }

                &.bg-danger {
                    border: 1px solid rgba($danger, .7);
                }
                &.bg-success {
                    border: 1px solid rgba($green, .7);
                }

                svg {
                    width: 1em;
                    height: 1em;
                    margin: 5px 0px 0 -1px;
                }
            }

            &__svg {
                margin-top: 7px;
            }

            &__view {
                display:inline-block;
                color: $primary;
                margin-top:5px;
                transition: all 0.2s ease-in-out;

                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
}
</style>